import Image from "next/image";
import React, { useState } from "react";
import LanguageCurrencyDropdown from "../Header/LanguageCurrencyDropdown";

const CreditCardInfo = () => {
  const [language, setLanguage] = useState("tr");
  const [currency, setCurrency] = useState("TL ₺");
  return (
    <div className="flex flex-wrap items-center justify-between gap-4 py-10">
      <div className="flex flex-wrap items-center gap-2" target="_blank">
        <Image
          src="/icons/iyzico.svg"
          width={80}
          height={40}
          alt="visa-light-large"
          className="object-contain"
        />
        <Image
          src="/icons/payments.svg"
          width={320}
          height={80}
          alt="payments"
          className="object-contain h-7 w-80"
        />
        <Image
          src="/icons/visa-light-large.svg"
          width={40}
          height={20}
          alt="visa-light-large"
          className="object-contain"
        />
        <Image
          src="/icons/mastercard-light-large.svg"
          width={40}
          height={20}
          alt="visa-light-large"
          className="object-contain"
        />
        <Image
          src="/icons/maestro-light-large.svg"
          width={40}
          height={20}
          alt="visa-light-large"
          className="object-contain"
        />
      </div>
      <LanguageCurrencyDropdown language={language} currency={currency} />
    </div>
  );
};

export default CreditCardInfo;
